import type { Nullable } from '~/types'
import type { BookingChangeRequestResponse } from '~/types/change-request'

/**
 * Returns a collection of basic change request details, advanced properties, and
 * helpers.
 *
 * @param changeRequest The change request to get the details for.
 * @returns The change request details.
 */
export function getChangeRequest(changeRequest?: Nullable<BookingChangeRequestResponse>) {
  // Base properties.
  const changeRequestAdults = changeRequest?.Adults ?? 0
  const changeRequestChildren = changeRequest?.Children ?? 0
  const changeRequestDeliveryDistance = changeRequest?.DeliveryDistance ?? 0
  const changeRequestDestination = changeRequest?.Destination ?? ''
  const changeRequestEndDate = changeRequest?.EndDate ?? undefined
  const changeRequestItemsAddAddOns = changeRequest?.ChangeRequestItems?.AddAddOns ?? []
  const changeRequestItemsRemoveAddOns = changeRequest?.ChangeRequestItems?.RemoveAddOns ?? []
  const changeRequestPets = Boolean(changeRequest?.Pets)
  const changeRequestRoadsideInsurance = changeRequest?.RoadSideInsurance
  const changeRequestRvUsage = changeRequest?.RvUsage
  const changeRequestStartDate = changeRequest?.StartDate ?? undefined

  // Advanced propeties.
  const changeRequestNumberOfNights = datetime.utc(changeRequestEndDate).diff(datetime.utc(changeRequestStartDate), 'days')

  return {
    changeRequestAdults,
    changeRequestChildren,
    changeRequestDeliveryDistance,
    changeRequestDestination,
    changeRequestEndDate,
    changeRequestItemsAddAddOns,
    changeRequestItemsRemoveAddOns,
    changeRequestPets,
    changeRequestRoadsideInsurance,
    changeRequestRvUsage,
    changeRequestStartDate,

    changeRequestNumberOfNights,
  }
}
